import { defineStore  } from 'pinia'
import tzDayjs from '@/utils/dayjs';
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useTableStore = defineStore('table', {
  state: () => ({
    tenantName: '',
    tableSessionId: '',
    tableNo: '',
    capacity: '',
    floor: '',
    type: '',
    customerCnt: 0,
    startTime : '',
    orders: [] // dishs and createTime
  }),

  getters : {
    totalCount : (state) => {
      return state.orders.reduce((total, order) => {
          return total + order.dishList.reduce((sum, dish) => { return sum + dish.quantity}, 0)
        }, 0)
    },

    totalPrice : (state) => {
      return state.orders.reduce((total, order) => {
          return total + order.dishList.reduce((sum, dish) => { return sum + dish.quantity * dish.price}, 0)
        }, 0)
    },

    dishes: (state) =>  {
      const dishes = []
      state.orders.forEach(m => { m.dishList.forEach( dish =>{
        dishes.push({
          ...dish
          ,orderId : m.orderId
          ,orderTime : m.orderTime
          ,isPaid : m.isPaid
          ,paidTime : m.paidTime
        }) 
      })})
      return dishes
    },

    paidOrders: (state) => {
      return state.dishes.filter(dish => dish.isPaid)
    },

    unpaidOrders: (state) => {
      return state.dishes.filter(dish => !dish.isPaid)
    },

    paidTotalPrice: (state) => {
      return state.paidOrders.reduce((total, dish) => {
          return total + dish.quantity * dish.price
        }, 0)
    },

    unpaidTotalPrice: (state) => {
      return state.unpaidOrders.reduce((total, dish) => {
          return total + dish.quantity * dish.price
        }, 0)
    }

  },
  
  actions: {
    updateState(obj){
      Object.keys(obj).forEach(key => {
        if (key in this.$state) {
          this[key] = obj[key]
        }
      })
    },

    setTableNo(tableNo){
      this.tableNo = tableNo
    },

    setCustomerCnt(customerCnt){
      this.customerCnt = customerCnt
    },

    setStartTime(){
      this.startTime = tzDayjs.getCurrentDateTime()
    },

    async getTableDetailByTableNo(){
      const res = await httpService.post(URL.TABLE_RETRIEVE, {tableNo:this.tableNo})
      // table信息设定
      this.updateState(res)
    },

    async getOrderList(){
      const res = await httpService.post(URL.ORDER_RETRIEVE, {tableNo:this.tableNo})
      this.orders = res
    },

    async checkout(){
      const orderIdList = this.unpaidOrders.map(order => order.orderId)
      await httpService.post(URL.ORDER_CHECKOUT, {orderIdList: Array.from(new Set(orderIdList))})
      await this.getOrderList()
    },

    async endOrder(){
      await httpService.post(URL.TABLE_FINISH, {tableNo:this.tableNo})
      this.tableSessionId = ''
      this.customerCnt = 0
      this.startTime = ''
      this.orders = []
    },

    async cancelDish(p){
      await httpService.post(URL.ORDER_DISH_CANCEL, p)
      await this.getOrderList()
    },

    customerCheckout(){
      httpService.post(URL.TABLE_CUSTOMER_CHECKOUT, {tableNo: this.tableNo})
    },

    async tableChange(tableNo){
      httpService.post(URL.TABLE_CHANGE, {curTableNo: this.tableNo, changeTableNo: tableNo})
    }
  }
});